import { LegacyCard, IndexTable, Text, Link, LegacyStack, Pagination, Badge, Divider, EmptyState } from '@shopify/polaris';
import { useEffect, useState, useContext } from 'react';
import { SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import { getSells } from '../../../services/sellsService';
import { useHistory } from 'react-router';
import fillZeros from '../../../helpers/fillZeros';
import moment from 'moment';

const SellsList = ({ page, onCreateNewSell }) => {
  const [, dispatchToast] = useContext(ToastContext);
  const [response, setResponse] = useState(null);
  const history = useHistory();
  const showSellEndpoint = (id) => `/sells/${id}?r=${window.btoa('/sells/page/' + response.metadata.page)}`;

  const getSellsList = (page = 1, limit = 10) =>
    getSells({ page, limit })
      .then((res) => {
        setResponse(res.data);
        history.push(`/sells/page/${page}`);
      })
      .catch((e) => dispatchToast({ type: SET_ERROR, payload: e.response.data }));

  useEffect(() => {
    getSellsList(page);
    // eslint-disable-next-line
  }, []);

  const headingMarkup = [
    { title: '' },
    { title: 'Cliente' },
    { title: 'Fecha' },
    { title: 'Depósito' },
    { title: 'Estado' },
    { title: 'Stock' },
  ];

  const rowMarkup = ({ id, status, createdAt, stockQty, invoiceDate, distinctProducts, customer, deposit }, index) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showSellEndpoint(id)}></Link>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          #{fillZeros(id, 4)}
        </Text>
      </IndexTable.Cell>

      <IndexTable.Cell>{customer.name}</IndexTable.Cell>

      <IndexTable.Cell>{moment(createdAt).format('DD/MM/YYYY')}</IndexTable.Cell>

      <IndexTable.Cell>{deposit.name}</IndexTable.Cell>

      <IndexTable.Cell>
        <>
          {status === 'DRAFT' && (
            <Badge
              status={distinctProducts > 0 ? 'attention' : 'new'}
              progress={distinctProducts > 0 ? 'partiallyComplete' : 'incomplete'}
            >
              {distinctProducts > 0 ? 'Borrador' : 'Nuevo'}
            </Badge>
          )}
          {status === 'INVOICED' && (
            <Badge status="success" progress="complete">
              Facturado
            </Badge>
          )}
        </>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text alignment="center">{Intl.NumberFormat('es-mx').format(stockQty)}</Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );

  return <>
    {response && !response.data.length && (
      <LegacyCard.Section>
        <EmptyState
          heading="Todavía no se ha creado ninguna venta"
          action={{
            content: 'Crear venta',
            onAction: () => onCreateNewSell(),
          }}
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        ></EmptyState>
      </LegacyCard.Section>
    )}
    {response && response.data.length > 0 && (
      <>
        <IndexTable
          resourceName={{
            singular: 'venta',
            plural: 'ventas',
          }}
          itemCount={response.data.length ?? 0}
          headings={headingMarkup}
          selectable={false}
        >
          {response.data.map((r, k) => rowMarkup(r, k))}
        </IndexTable>
        <Divider borderStyle="divider" />
        <LegacyCard.Section>
          <LegacyStack distribution="center">
            <Pagination
              hasPrevious={response.metadata.prev}
              onPrevious={() => getSellsList(response.metadata.page - 1, response.metadata.limit)}
              hasNext={response.metadata.next}
              onNext={() => getSellsList(response.metadata.page + 1, response.metadata.limit)}
            />
          </LegacyStack>
        </LegacyCard.Section>
      </>
    )}
  </>;
};

export default SellsList;
